<template>
  <div>
    <div style="padding:16px 0 0 0">
      <storyly-web ref="storylyWeb"></storyly-web>
    </div>  

    <SearchBar />
    <Hero />
    <section>
      <v-container>
        <v-row justify="space-between">
          <v-col>
            <h3 class="d-inline-block">Dalam Waktu Dekat</h3>
            <p class="grey--text">Buruan daftar sebelum ketinggalan</p>
          </v-col>
        </v-row>
        <div v-if="section3.length > 0">
          <v-row v-if="loading">
            <v-col cols="12" md="3" v-for="(item, i) in 8" :key="i">
              <v-skeleton-loader type="card"></v-skeleton-loader>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="12" md="3" v-for="(item, i) in section3" :key="i">
              <PosterCard
                :title="item.title"
                :date="item.event_date"
                :publisher="item.publisher"
                :publisher_badge="item.publisher_badge"
                :poster="item.cover"
                :route="{
                  name: 'EventDetail',
                  params: { slug: item.slug, id: item.id },
                }"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn text color="primary" :to="{ name: 'Explore' }"
                >Lihat Semua</v-btn
              >
            </v-col>
          </v-row>
        </div>
        <div v-else>
          <EmpytState />
        </div>
      </v-container>
    </section>

    <section>
      <CatalogueEventRecommendation />
    </section>

    <section>
      <v-container>
        <v-row justify="space-between">
          <v-col>
            <h3 class="d-inline-block">Webinar Yang Lagi Tenar</h3>
            <p class="grey--text">
              Tetap rebahan #DirumahAja tetep bisa mengikuti seminar
            </p>
          </v-col>
        </v-row>
        <div v-if="sectionWebinar.length > 0">
          <v-row v-if="loading">
            <v-col cols="12" md="3" v-for="(item, i) in 8" :key="i">
              <v-skeleton-loader type="card"></v-skeleton-loader>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col
              cols="12"
              sm="6"
              md="3"
              v-for="(item, i) in sectionWebinar"
              :key="i"
            >
              <PosterCard
                :title="item.title"
                :date="item.event_date"
                :publisher="item.publisher"
                :publisher_badge="item.publisher_badge"
                :poster="item.cover"
                :route="{
                  name: 'EventDetail',
                  params: { slug: item.slug, id: item.id },
                }"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn text color="primary" :to="{ name: 'Explore' }"
                >Lihat Semua</v-btn
              >
            </v-col>
          </v-row>
        </div>
        <div v-else>
          <EmpytState />
        </div>
      </v-container>
    </section>

    <v-parallax src="img/parallax-img.jpg" height="400">
      <v-container>
        <v-row>
          <v-col cols="12" md="8">
            <h2>Buat event kamu sendiri disini Gratis</h2>
            <p>Daftarkan profil Organisasi dan posting Acara kamu sekarang</p>
          </v-col>
          <v-col cols="12" md="4">
            <v-btn
              color="amber darken-1"
              block
              large
              target="_blank"
              link
              :href="gotoApp"
              >Buat Event</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </v-parallax>

    <section>
      <v-container>
        <v-row>
          <v-col cols="12" md="8">
            <h2>Tersedia dalam gengaman</h2>
            <p>Kini kamu dapat mendownload aplikasi di Google Playstore</p>
          </v-col>
          <v-col
            cols="12"
            md="4"
            class="d-flex justify-center align-center align-content-center"
          >
            <a
              href="https://play.google.com/store/apps/details?id=id.pwa.eventversity&utm_source=web-cf&utm_campaign=web-cta&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
              target="_blank"
              ><img
                width="200"
                alt="Temukan di Google Play"
                src="https://play.google.com/intl/en_us/badges/static/images/badges/id_badge_web_generic.png"
            /></a>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <section>
      <CatalogueEvent />
    </section>

    <v-snackbar v-model="error">
      {{ errorMessage }}
      <v-btn dark color="pink" text @click="error = false"> Close </v-btn>
    </v-snackbar>

    <!--    <div-->
    <!--      id="g_id_onload"-->
    <!--      data-client_id="404766723014-556ceqqifjaf150535o42056a1544phk.apps.googleusercontent.com"-->
    <!--      data-callback="handleCredentialResponse"-->
    <!--    ></div>-->
  </div>
</template>

<script>
// @ is an alias to /src

import Hero from '../components/Hero';
import PosterCard from '../components/PosterCard';
import Axios from 'axios';
import CatalogueEvent from '../components/CatalogueEvent';
import SearchBar from '../components/SearchBar';
import EmpytState from '@/components/EmpytState';
import CatalogueEventRecommendation from '@/components/CatalogueEventRecommendation';

export default {
  name: 'Home',
  components: {
    CatalogueEventRecommendation,
    EmpytState,
    SearchBar,
    CatalogueEvent,
    PosterCard,
    Hero,
  },
  data: () => ({
    loading: true,
    loadData: [],
    error: false,
    errorMessage: null,
    gotoApp: process.env.VUE_APP_DASHBOARD,
    metaInfo: {
      title: 'My Example App',
      titleTemplate: '%s - Yay!',
      htmlAttrs: {
        lang: 'en',
        amp: true,
      },
    },
  }),
  mounted() {
    Axios.get(process.env.VUE_APP_API + 'events')
      .then((response) => {
        this.loadData = response.data.data;
      })
      .catch((error) => {
        console.log(error);
        this.error = true;
        this.errorMessage = error;
      })
      .finally(() => (this.loading = false));

    this.$refs.storylyWeb.init({
      token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhY2NfaWQiOjY4MjYsImFwcF9pZCI6MTEyMTcsImluc19pZCI6MTE5NTh9.W1adZSIviX15sidAUau-OQKNtW-qqItOYFuLJS1S1EQ',
      props: { 
        storyGroupSize: '58x58',
        storyGroupTextLineHeight: '1.2',
        storyGroupIconBorderColorNotSeen: ['#FF208B'],
        storyGroupIconBorderColorSeen: ['#eeeeee'],
        storyGroupBorderRadius: '100',
        storyGroupMarginHorizontal: '4',
        storyGroupTextWeight: 'bold',
        storyGroupTextMarginTop: '12',
        storyGroupTextSize: '10',
        storyBorderGapSize: '4',
        storyGroupAlign: 'center',
        storyGroupAnimation: {
          type: "pulse",
          mode: false,
        },
      },
      customStoryGroupHTML: "HTML",
    });
  },
  computed: {
    webinar: function () {
      return this.loadData.filter(function (loadData) {
        return loadData.is_online == 1;
      });
    },
    sectionWebinar() {
      return this.webinar.slice(0, 8);
    },
    section3() {
      return this.loadData.slice(0, 8);
    },
  },
  methods: {},
};
</script>

<style scoped>
section {
  border-bottom: solid 10px #fafafa;
}

.custom-story-group-container {
      cursor: pointer;
      height: 230px;
      width: 107px;
      margin-right: 24px;
    }
    .custom-story-group-container .custom-story-group {
      position: relative;
      cursor: pointer;
      height: 190px;
      width: 107px;
      border-radius: 16px;
      border: 1px solid rgba(0, 0, 0, 0.2);
    }
    .custom-story-group .storyly__story-preview {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      border-radius: 16px;
    }
    .custom-story-group .storyly__story-group-cover {
      height: 72px;
      width: 72px;
      border-radius: 50%;
      position: absolute;
      bottom: -36px;
      left: 18px;
      border: 3px solid #ffffff;
      box-sizing: border-box;
      filter: drop-shadow(0px 16px 20px rgba(36, 36, 80, 0.16));
    }
    .custom-story-group .storyly__story-group-pin {
      z-index: 1;
      position: absolute;
      right: 8px;
      top: 8px;
    }
</style>
